
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("99rcJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $824lD = parcelRequire("824lD");


var $huaOC = parcelRequire("huaOC");


var $1NBp8 = parcelRequire("1NBp8");


var $luv00 = parcelRequire("luv00");


var $2U9QW = parcelRequire("2U9QW");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1ytiN = parcelRequire("1ytiN");


var $dPJCf = parcelRequire("dPJCf");

const $544e89ef74bbdb03$export$5bc2ad8fe7e5e700 = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const showTCNav = edition === (0, $euL71.ConfluenceEdition).STANDARD ? isSiteAdmin : true;
    let t0;
    if ($[0] !== props || $[1] !== showTCNav) {
        t0 = showTCNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($544e89ef74bbdb03$var$CalendarsLinkInner, props) : null;
        $[0] = props;
        $[1] = showTCNav;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $544e89ef74bbdb03$var$CalendarsLinkInner = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { onClick: onClick } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSelected = (0, $dPJCf.useRouteName)($544e89ef74bbdb03$var$isOnSCalendarsRoute);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $544e89ef74bbdb03$var$i18n.calendarsTooltip);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== spaceKey) {
        t2 = (0, $1NBp8.SPACE_CALENDARS).toUrl({
            spaceKey: spaceKey
        });
        $[1] = spaceKey;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
            label: "",
            color: "currentColor"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $544e89ef74bbdb03$var$i18n.calendars);
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2U9QW.PremiumLozengeLoadable), null);
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] !== isSelected || $[7] !== onClick || $[8] !== ssrPlaceholderIdProp || $[9] !== t2) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "top",
            content: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: t2,
            onClick: onClick,
            elemBefore: t3,
            isSelected: isSelected,
            "data-vc": "team-calendar-navigation",
            ...ssrPlaceholderIdProp
        }, t4, t5));
        $[6] = isSelected;
        $[7] = onClick;
        $[8] = ssrPlaceholderIdProp;
        $[9] = t2;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
};
const $544e89ef74bbdb03$var$isOnSCalendarsRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_CALENDARS).name || routeName === (0, $1NBp8.SPACE_CALENDARS_SUBCALENDAR).name
};
const $544e89ef74bbdb03$var$i18n = (0, $kSwu1.defineMessages)({
    calendarsTooltip: {
        id: "side-navigation.space-navigation.calendars.tooltip",
        defaultMessage: "View calendar"
    },
    calendars: {
        id: "side-navigation.space-navigation.calendars",
        defaultMessage: "Calendars"
    }
});
module.exports["CalendarsLink"] = $544e89ef74bbdb03$export$5bc2ad8fe7e5e700;

});

parcelRegister("2U9QW", function(module, exports) {
$parcel$export(module.exports, "PremiumLozengeUi", () => (parcelRequire("gkc4E")).PremiumLozenge);

var $jmjWc = parcelRequire("jmjWc");


var $gkc4E = parcelRequire("gkc4E");


const $ea97352de2ccf604$export$62673719cbe80cd0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "cJMmb",
    name: "PremiumLozengeLoadable",
    loader: async ()=>(await (parcelRequire("icPLN"))).PremiumLozenge
});
module.exports["PremiumLozengeLoadable"] = $ea97352de2ccf604$export$62673719cbe80cd0;

});

parcelRegister("icPLN", function(module, exports) {

let $d411816af12a9cb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d411816af12a9cb3$var$load("4yUSc").then(()=>parcelRequire('9xi4O'));

});

parcelRegister("gkc4E", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");

const $6eab09cc616c0de0$var$messages = (0, $kSwu1.defineMessages)({
    premium: {
        id: "trial-components.lozenge.premium",
        defaultMessage: "Premium"
    }
});
const $6eab09cc616c0de0$export$b37ef9640eaa3746 = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6eab09cc616c0de0$var$messages.premium));
};
module.exports["PremiumLozenge"] = $6eab09cc616c0de0$export$b37ef9640eaa3746;

});


//# sourceMappingURL=CalendarsLink.df5a1060.js.map
